import { Partner } from "@/model/Partner";

export class Zahlungsdaten {
  zahlungsart = "";
  kontoinhaberPartner = new Partner();
  iban = "";
  kontoinhaberPartnerRolle = "";
}
